// Функция для инициализации кнопки Показать ещё.
// При вызове аргументами передаются селектор блока, в котором нужен данный функционал, а также количество элементов, видимых изначально. Например, initShowMoreButton('.program', 4);
// При вёрстке кнопке добавить класс .show-button для стилизации, если нужны специфические стили для кнопки, то стилизовать каскадом от родителя. Например, 
//    .program {
//       .show-button {
//          ...  
//       }   
//    }
// Также кнопке ОБЯЗАТЕЛЬНО добавить атрибут data-show-button
// Также ОБЯЗАТЕЛЬНО добавить атрибут data-collapse-item всем элементам из раскрывающегося списка, даже если они видимы изначально

const initShowMoreButton = (container, visibleItems) => {
   const itemsContainer = document.querySelector(container);
   if (!itemsContainer) return;
   const showMoreButton = itemsContainer.querySelector("[data-show-button]");
   let items = Array.from(itemsContainer.querySelectorAll("[data-collapse-item]")).filter((item) => item.style.display !== "none"),
      hiddenItems = items.slice(visibleItems);

   // Обнуление перед переинициализацией
   const resetParameters = () => {
      items.forEach(item => {
         item.style.display = null;
         item.style.opacity = 1;
      });
   
      if (showMoreButton) {
         showMoreButton.classList.remove("hidden");
         showMoreButton.textContent = "Показать еще";
      }
      
      if (items.length <= visibleItems) {
         showMoreButton?.classList.add("hidden");
         return;
      };
      
      hiddenItems.forEach((item) => {
         item.style.display = 'none';
         item.style.opacity = 0;
      });
   }

   resetParameters();

   const onShowMoreButtonClick = () => {
      hiddenItems.forEach((item) => {
         item.style.display = null;
         setTimeout(() => {
            item.style.opacity = 1;
         });
      });
      showMoreButton.textContent = "Свернуть";
      showMoreButton.removeEventListener("click", onShowMoreButtonClick);
      showMoreButton.addEventListener("click", onCollapseButtonClick);
   }

   const onCollapseButtonClick = () => {
      hiddenItems.forEach((item) => {
         setTimeout(() => {
            item.style.display = 'none';
         }, 250);
         item.style.opacity = 0;
      });
      showMoreButton.textContent = "Показать еще";
      showMoreButton.removeEventListener("click", onCollapseButtonClick);
      showMoreButton.addEventListener("click", onShowMoreButtonClick);
   }

   showMoreButton?.addEventListener("click", onShowMoreButtonClick);

   document.addEventListener('click', (evt) => {
      if (evt.target.closest('[data-filter]')) {
         showMoreButton?.removeEventListener("click", onCollapseButtonClick);
         items = Array.from(itemsContainer.querySelectorAll("[data-collapse-item]")).filter((item) => item.style.display !== "none");
         hiddenItems = items.slice(visibleItems);
         resetParameters();
         showMoreButton?.addEventListener("click", onShowMoreButtonClick);
      } 
   })
};

export default initShowMoreButton;
